export const formatFolderRawData = (rawData) => rawData.map(ele => ({
  id: ele.id,
  folderName: ele.folder_name,
  createdAt: ele.created_at,
  updatedAt: ele.updated_at,
  isActive: ele.is_active
}))



// WEBPACK FOOTER //
// ./src/components/audience-builder/manageFolder/helpers.js